import React from 'react';
import styled, { keyframes } from 'styled-components';

const testimonials = [
  {
    name: 'Anand Rastogi',
    title: 'Founder, Succesship',
    company: 'Succesship',
    category: 'SaaS Enterprise',
    quote:
      'htraction matched us with relevant investors quickly and seamlessly. Their focus on simplifying the fundraising experience truly reflects in the application journey'
  },
  {
    name: 'Amit Soni',
    title: 'Co-Founder & CEO, DhanXpert',
    company: 'DhanXpert',
    category: 'Fintech',
    quote:
      'htraction helped us get discovered by the right investors, streamlining our outreach and strengthening our fundraising journey with real focus and precision'
  },
  {
    name: 'Rathnakar Samavedam',
    title: 'CEO, Hyderabad Angels',
    company: 'Hyderabad Angels',
    category: 'Angel Investor',
    quote:
      'htraction brings clarity to early-stage investing. The platform’s intelligence layer offers sharp evaluation, efficient startup matching, and data-driven insights, saving time and elevating our investor experience.'
  },
  {
    name: 'Presen Narayan',
    title: 'Founder, Zippi',
    company: 'Zippi',
    category: 'Logistics Tech',
    quote:
      'htraction stands out as a truly intelligent platform that redefines how startups approach fundraising. A powerful ally for any startup looking to navigate the funding journey with clarity and confidence.'
  }
];

const duplicatedTestimonials = [...testimonials, ...testimonials];

const Testimonial: React.FC = () => {
  return (
    <Section>
      <Container>
        <Title>Trusted by <span>founders</span> and <span>investors</span></Title>
        <Subtitle>
          Startup teams and capital partners rely on htraction to move faster with confidence. Here’s what
          they say about working with us.
        </Subtitle>

        <Carousel>
          <Track>
            {duplicatedTestimonials.map((item, index) => (
              <Card key={`${item.name}-${index}`}>
                <CardHeader>
                  <Company>{item.company}</Company>
                  <Category>{item.category}</Category>
                </CardHeader>
                <Quote>“{item.quote}”</Quote>
                <AuthorBlock>
                  <Avatar>{item.name.charAt(0)}</Avatar>
                  <AuthorInfo>
                    <Name>{item.name}</Name>
                    <Role>{item.title}</Role>
                  </AuthorInfo>
                </AuthorBlock>
              </Card>
            ))}
          </Track>
        </Carousel>
      </Container>
    </Section>
  );
};

const Section = styled.section`
  padding: 20px 0;
  background-color: #fff;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
  text-align: center;
`;

const Title = styled.h2`
  font-size: clamp(24px, 4vw, 52px);
  margin: 16px 0 12px;
  font-weight: 700;
  color: #111c2b;
    span {
    background: linear-gradient(90deg, #FF5733, #FF8C00);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: rgba(17, 28, 43, 0.7);
  max-width: 640px;
  margin: 0 auto 32px;
  line-height: 1.6;
`;

const scroll = keyframes`
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
`;

const Carousel = styled.div`
  position: relative;
  overflow: hidden;
  padding: 20px 0;
`;

const Track = styled.div`
  display: flex;
  gap: 24px;
  width: fit-content;
  animation: ${scroll} 30s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
`;

const Card = styled.article`
  flex: 0 0 320px;
  padding: 32px;
  border-radius: 24px;
  background: #ffffff;
  box-shadow: 0 20px 40px rgba(255, 89, 36, 0.1);
  border: 0.5px solid rgba(255, 91, 36, 0.3);
  text-align: left;
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 25px 55px rgba(255, 89, 36, 0.25);
    border-color: #ff5924;
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: rgba(15, 27, 45, 0.6);
  margin-bottom: 12px;
`;

const Company = styled.span`
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const Category = styled.span`
  color: #ff5924;
`;

const Quote = styled.p`
  font-size: 18px;
  line-height: 1.6;
  color: rgba(15, 27, 45, 0.85);
  min-height: 130px;
`;

const AuthorBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 16px;
`;

const Avatar = styled.span`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #ff8c52, #ff5924);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
`;

const AuthorInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const Name = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #0f1b2d;
`;

const Role = styled.span`
  font-size: 14px;
  color: rgba(15, 27, 45, 0.7);
`;

export default Testimonial;
